import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@getgo/chameleon-material-ui';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import classes from './index.module.scss';
const TextTruncate = ({ children, className }) => {
    var _a, _b;
    const [truncated, setTruncated] = useState(false);
    const [mouseOver, setMouseOver] = useState(false);
    const ref = useRef(null);
    const onMouseOver = () => setMouseOver(true);
    const onMouseLeave = () => setMouseOver(false);
    useEffect(() => {
        const refCurrent = ref === null || ref === void 0 ? void 0 : ref.current;
        if ((refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.offsetWidth) < (refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.scrollWidth))
            setTruncated(true);
        else
            setTruncated(false);
    }, [truncated, (_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWith, (_b = ref.current) === null || _b === void 0 ? void 0 : _b.scrollWidth]);
    return (_jsx(Tooltip, Object.assign({ open: truncated && mouseOver, title: children, arrow: true, placement: "top-start" }, { children: _jsx("span", Object.assign({ className: classNames(classes.truncate, className), ref: ref, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave }, { children: children }), void 0) }), void 0));
};
export default TextTruncate;
//# sourceMappingURL=index.js.map